let current: number = 1;

export function uid(): string {
  return `uid-${current++}`;
}



// WEBPACK FOOTER //
// ./src/utils/uid.ts